import { render } from "./SuggestedSystemPieChart.vue?vue&type=template&id=387fb2a2&scoped=true&ts=true"
import script from "./SuggestedSystemPieChart.vue?vue&type=script&lang=ts"
export * from "./SuggestedSystemPieChart.vue?vue&type=script&lang=ts"

import "./SuggestedSystemPieChart.vue?vue&type=style&index=0&id=387fb2a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387fb2a2"]])

export default __exports__